// Require

const { id, log, randomFrom, min } = require("../std/index")


// Meta

const allSlices = {};

const sliceId = (() => {
  let i = 0;
  return () => 's' + i++;
})();

let sliceAddCallback = id;

const onSliceAdded = (callback) => {
  sliceAddCallback = callback;
};


// Slices Library

const Slices = {
  'blank': require('./blank'),
  'specials': require('./specials'),
  'recipe': require('./recipe'),
  'which': require('./which'),
  'natural': require('./natural'),
  'superior': require('./superior')
};


// Functions

const getInstanceFrom = ($target) => {
  const data = $target.data();

  // Error gauntlet
  if ($target.length < 1) {
    return log("Tried to get slice instance of empty selection:", $target.selector);
  }

  if (!data.sliceId) {
    return log("Element has no slice instance ID:", $target[0]);
  }

  if (!allSlices[data.sliceId]) {
    return log("Tried to get slice instance from", $target[0], "but couldn't find one.");
  }

  // Finally, everything works
  return allSlices[data.sliceId];
};

const initSlice = (ix, target) => {
  const $this = $(target);
  const config = $this.data();
  const type = config.slice;

  if (type && Slices[type]) {
    const newId = sliceId();
    config.sliceId = newId;
    $this.data('sliceId', newId);
    allSlices[newId] = new Slices[type]($this, config);
    sliceAddCallback(allSlices[newId], allSlices);
  } else {
    console?.warn('Unknown slice:', type);
  }
};

module.exports = {
  allSlices,
  onSliceAdded,
  getInstanceFrom,
  initSlice
};
